export type AssistantUserSummary = {
  id: string
  salutation: string | null
  first_name: string
  surname: string
  email: string
  phone_number: string | null
  is_active: boolean
}

export type AssistantDoctorSummary = {
  id: string
  first_name: string
  surname: string
  email: string
}

export type AssistantDoctorLink = {
  id: string
  assistant_id: string
  doctor_id: string
  can_create_cases: boolean
  can_set_global: boolean
  can_manage_review: boolean
  can_update_outcome: boolean
  created_at: string | null
  deleted_at: string | null
  assistant?: AssistantUserSummary
  doctor?: AssistantDoctorSummary
}

export type AssistantListParams = {
  with_trashed?: boolean
  /** When true, list only soft-deleted links (Show Deleted filter). */
  only_trashed?: boolean
  page?: number
  per_page?: number
  search?: string
  name?: string
  email?: string
  doctor_id?: string
  account_active?: boolean
}

export type AssistantCreatePayload = {
  salutation: string
  first_name: string
  surname: string
  email: string
  phone_number?: string
  position_id?: string
  doctor_id?: string
  can_create_cases?: boolean
  can_set_global?: boolean
  can_manage_review?: boolean
  can_update_outcome?: boolean
}

export type AssistantUpdatePayload = {
  can_create_cases?: boolean
  can_set_global?: boolean
  can_manage_review?: boolean
  can_update_outcome?: boolean
}

export const ASSISTANT_SALUTATION_OPTIONS = [
  { value: 'miss', label: 'Miss' },
  { value: 'mr', label: 'Mr' },
  { value: 'mrs', label: 'Mrs' },
  { value: 'ms', label: 'Ms' },
  { value: 'dr', label: 'Dr' },
  { value: 'prof', label: 'Prof' },
] as const
